<template>
    <section class="section section-lg bg-default">
        <div class="container container-wide">
            <b-alert :show="!this.isEmpty(this.paramError)" variant="danger" dismissible fade><div class="alert-content" v-html="this.paramErrors[this.paramError] || this.paramErrors['default']"></div></b-alert>
            <b-alert :show="!this.isEmpty(this.eowp.stripeSync)" :variant="this.eowp.stripeSync == this.eowp.stripeSyncFlags.SUCCESS ? 'success' : 'danger'" dismissible fade><div class="alert-content">{{ this.eowp.stripeSyncMessage[this.eowp.stripeSync] }}</div></b-alert>
            <b-alert :show="hasPendingSync" variant="info" dismissible><div class="alert-content">{{ this.eowp.stripeSyncPending.message }}</div></b-alert>
            <b-alert v-if="!this.isEmpty(this.eowp.transition) && !this.isEmpty(this.eowp.transitionMessage[this.eowp.transition])" :variant="this.eowp.transition.indexOf('err') < 0 ? 'success' : 'danger'" dismissible fade><div class="alert-content">{{ this.eowp.transitionMessage[this.eowp.transition] }}</div></b-alert>
            <div class="row row-fix row-50 justify-content-lg-center">
                <div class="col-lg-11 col-xl-10 col-xxl-6 table-containers">
                    <div class="tabs-custom tabs-horizontal tabs-line text-center" id="tabs-1">
                        <!-- Nav tabs-->
                        <ul class="nav nav-tabs nav-tabs-checkout">
                            <li class="nav-item">
                                <a
                                    class="nav-link"
                                    href="#tabs-1-2"
                                    data-toggle="tab"
                                >アカウントページ</a>
                            </li>
                        </ul>
                        <div>
                            <span class="header-instruction" v-html="headerInstructions"></span>
                        </div>
                        <div v-if="pageLoadingIndicator" class="page-loading-indicator">
                            <img src="/images/eowp/animation/loading-spinner.jpg" />
                        </div>
                        <!-- Tab panes-->
                        <div class="tab-content">
                            <div class="tab-pane fade show active" id="tabs-1-2">
                                <div class="table-checkout text-left">
                                    <!-- MOBILE VERSION - PART1 --------------------->
                                    <div class="table-novi table-custom-responsive mobile-component" v-if="eowp.accountStatus.hasCurrentSubscription || eowp.accountStatus.hasPreviousShopSubscription || eowp.accountStatus.noRecords || eowp.kakin.hasRecord">
                                        <table class="table-custom table-custom-bordered">
                                            <thead>
                                                <tr>
                                                    <th class="th-header"><span class="row-text detail-title">サービス情報詳細</span></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr class="content-row">
                                                    <td>
                                                        <div class="mobile-div-text"><span class="row-text">ご注文番号：{{eowp.subscription.csOrderNo}}</span></div>
                                                        <div class="mobile-div-text"><span class="row-text">ご注文日：{{eowp.subscription.oldSubscription ? eowp.subscription.oldSubscription.orderDate : eowp.subscription.orderDate}}</span></div>
                                                    </td>
                                                </tr>
                                                <tr class="content-row" v-if="eowp.subscription.oldSubscription">
                                                    <td>
                                                        <div class="mobile-div-text"><span class="row-text">※ ご注文番号の変更のお知らせ：{{eowp.subscription.oldSubscription.csOrderNo}} から変更されております。</span></div>
                                                    </td>
                                                </tr>
                                                <tr class="content-row" v-if="eowp.subscription.csOrderNo">
                                                    <td>
                                                        <div class="mobile-div-text"><span class="row-text">{{getItemName(eowp.subscription.csMatNo)}}</span></div>
                                                        <div 
                                                            @click="redirect('/products', 'switch_to_yearly_click')"
                                                            v-if="eowp.subscriptionType == 'MONTHLY' && notIn(eowp.subscription.useStatus, '0,2,3')"
                                                            class="button buttons button-xls button-default-outline mobile-button1">
                                                            年額へ切り替え
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr class="content-row" v-if="eowp.kakin.hasRecord">
                                                    <td>
                                                        <div class="mobile-div-text"><span class="row-text">{{eowp.kakin.chargeTypes[eowp.kakin.record.chargeType]}}</span></div>
                                                    </td>
                                                </tr>
                                                <tr class="content-row" v-if="eowp.subscription.csOrderNo || eowp.kakin.hasRecord">
                                                    <td>
                                                        <div class="mobile-div-text"><span class="row-text">◆ご利用状況</span></div>
                                                    </td>
                                                </tr>
                                                <tr class="content-row" v-if="eowp.subscription.csOrderNo || eowp.kakin.hasRecord">
                                                    <td v-if="eowp.subscription.useStatus == '1'">
                                                        <div class="mobile-div-text" v-if="eowp.subscriptionType == 'MONTHLY'">
                                                            <span class="font-bold" :class="this.eowp.subscriptionInfo.onTrialPeriod ? 'color-darkblue' : 'color-green'" v-html="eowp.subscriptionInfo.paymentReminder"></span>・当サービスは <strong>{{eowp.subscriptionInfo.nextBillingDate}}</strong> に自動継続され、¥<strong>{{formatPrice(eowp.subscriptionInfo.nextBillingAmount)}}</strong> をご請求いたします。
                                                        </div>
                                                        <div class="mobile-div-text" v-if="eowp.subscriptionType == 'YEARLY'">
                                                            <span class="font-bold" :class="this.eowp.subscriptionInfo.onTrialPeriod ? 'color-darkblue' : 'color-green'" v-html="eowp.subscriptionInfo.paymentReminder"></span>・当サービスは <strong>{{eowp.subscriptionInfo.nextBillingDate}}</strong> に自動継続され、¥<strong>{{formatPrice(eowp.subscriptionInfo.nextBillingAmount)}}</strong> をご請求いたします。
                                                        </div>
                                                    </td>
                                                    <td v-if="eowp.subscription.useStatus == '0'">
                                                        <span class="row-text">{{ currentAccountStatusMessage }}</span>
                                                    </td>
                                                    <td v-if="eowp.subscription.useStatus == '2'">
                                                        <div class="mobile-div-text" v-show="!eowp.validToExpired || forcePayment()">
                                                            <span class="row-text-contents text-justify"><span class="suspended-highlight color-red">サービス停止中</span>・利用を自動継続するには、<strong>{{eowp.subscriptionInfo.currentPeriodEnd}}</strong> までにカード情報の変更をお願いします。その際、未払いの料金 (<strong>¥{{formatPrice(eowp.subscriptionInfo.nextBillingAmount)}}</strong>) をご請求いたします。<strong>{{eowp.subscriptionInfo.currentPeriodEnd}}</strong> までにお手続きいただかないと、そのまま利用停止となります</span>
                                                        </div>
                                                        <div class="mobile-div-text" v-show="eowp.validToExpired && !forcePayment() && eowp.subscriptionType == 'MONTHLY'">
                                                            <span class="row-text row-with-sub-link">{{accountStatusMessages.stoppedBySystem}}</span>
                                                        </div>
                                                        <div class="mobile-div-text" v-show="eowp.validToExpired && !forcePayment() && eowp.subscriptionType == 'YEARLY'">
                                                            <span class="row-text">{{accountStatusMessages.stoppedBySystem}}</span>
                                                        </div>
                                                    </td>
                                                    <td v-if="eowp.subscription.useStatus == '3'">
                                                        <div class="mobile-div-text">
                                                            <span class="row-text-contents text-justify"><span class="font-bold" :class="this.eowp.subscriptionInfo.onTrialPeriod ? 'color-darkblue' : 'color-green'" v-html="eowp.subscriptionInfo.paymentReminder"></span>・コース切り替え済み : <strong>{{eowp.subscriptionInfo.nextBillingDate}}</strong> より<strong>年額コース</strong>でのご利用となり、¥<strong>{{formatPrice(eowp.subscriptionInfo.nextBillingAmount)}}</strong> をご請求いたします。</span>
                                                        </div>
                                                    </td>
                                                    <td v-if="eowp.kakin.hasRecord">
                                                        <div class="mobile-div-text">
                                                            <span class="row-text">ご利用中：サービスをご利用いただけます。</span>
                                                        </div>
                                                    </td>
                                                </tr>

                                                <tr class="content-row" v-if="eowp.kakin.hasRecord">
                                                    <td>
                                                        <div class="mobile-div-text">
                                                            <span class="row-text">有効期間の確認・カード情報の変更・利用停止のお手続きは、ご購入いただいたアプリストアまたは法人申し込み窓口にてお願いいたします。</span>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <!-- Disable link to survey page, so we only currently offer survey to users during Cancellation Process-->
                                                <!-- <tr class="content-row" v-if="eowp.subscription.useStatus == '0'">
                                                    <td v-if="eowp.subscription.useStatus == '0'">
                                                        <div class="mobile-div-text">
                                                            <span class="row-text row-with-sub-link">よろしければ、ご利用停止の
                                                                <a class="sub-link" href="#" @click.prevent="redirect('/survey')">アンケート</a>
                                                                    にご協力ください。
                                                                </span>
                                                        </div>
                                                    </td>
                                                </tr> -->
                                                <tr class="content-row" v-if="eowp.subscription.csOrderNo">
                                                    <td>
                                                        <div class="mobile-div-text">
                                                            <span class="row-text">利用開始日 : {{eowp.subscription.oldSubscription ? eowp.subscription.oldSubscription.validFrom : eowp.subscription.validFrom}}</span>
                                                        </div>
                                                        <div 
                                                            @click="changeCC(eowp.subscription.sendId, eowp.subscription.csOrderNo)"
                                                            v-if="(eowp.subscription.useStatus != '0' && !eowp.validToExpired) || forcePayment()" 
                                                            class="button buttons button-xs button-default-outline change-credit-card mobile-button2">
                                                            カード情報の変更・更新
                                                        </div>
                                                        <div @click="confirmSubscriptionInfoDialog()" v-if="showSubscriptionInfoLink() && ((eowp.subscription.useStatus != '0' && !eowp.validToExpired) || forcePayment())" class="subscription-info-link subscription-info-link-mobile">{{eowp.subscriptionInfo.cardInfoLinkText}}</div> 
                                                    </td>
                                                </tr>
                                                <tr class="content-row" v-if="eowp.subscription.csOrderNo">
                                                    <td>
                                                        <div class="mobile-div-text" v-if="eowp.subscription.useStatus != '0'">
                                                            <span class="row-text">利用停止日 : {{eowp.subscriptionCycle[eowp.subscription.useStatus]}}</span>
                                                        </div>
                                                        <div class="mobile-div-text" v-if="eowp.subscription.useStatus == '0'">
                                                            <span class="row-text">
                                                                利用停止日 : {{transformUseDescription(eowp.textReference[2], eowp.subscription.validTo)}} {{eowp.validToExpired ? '' : '（予定）'}}
                                                            </span>
                                                        </div>
                                                        <div @click="updateService(eowp.requestType.RESUME, 'resume_subscription_click')" v-if="!eowp.validToExpired && eowp.subscription.useStatus == '0'" class="button buttons button-xs button-default-outline mobile-button3" v-bind:class="{'update-subscription-button disabled': isUpdateSubscriptionInProgress, 'disabled' : eowp.controlSetting.paymentGateway.status == eowp.controlSetting.DISABLED}">再開する</div>
                                                        <div @click="updateService(eowp.requestType.STOP, 'stop_subscription_click')" v-if="!eowp.validToExpired && !notIn(eowp.subscription.useStatus, '1,3')" class="button buttons button-xs button-default-outline mobile-button3" v-bind:class="{'update-subscription-button disabled': isUpdateSubscriptionInProgress, 'disabled' : eowp.controlSetting.paymentGateway.status == eowp.controlSetting.DISABLED}">停止する</div>
                                                        <div v-if="eowp.controlSetting.paymentGateway.status == eowp.controlSetting.DISABLED" class="update-subscription-button-info">
                                                            <ul>
                                                            <li>メンテナンス中のため変更を一次停止しております。</li>
                                                            </ul>
                                                        </div>
                                                        <div @click="redirect('/products', 'reorder_button_click')" v-if="(eowp.validToExpired && eowp.subscription.useStatus == '0')||(eowp.validToExpired && (eowp.subscription.useStatus == '2' && eowp.validToExpired) && !forcePayment())" class="button buttons button-xs button-default-outline mobile-button3">再購入する</div>
                                                        <div @click="confirmSubscriptionInfoDialog()" v-if="showSubscriptionInfoLink() && !eowp.validToExpired && eowp.subscription.useStatus == '0'" class="subscription-info-link subscription-info-link-mobile2">{{eowp.subscriptionInfo.cardInfoLinkText}}</div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <!-- END MOBILE VERSION - PART1 --------------------->

                                    <!-- DESKTOP VERSION - PART1 ------------------------>
                                    <div class="table-novi table-custom-responsive desktop-component" v-if="eowp.accountStatus.hasCurrentSubscription || eowp.accountStatus.hasPreviousShopSubscription || eowp.accountStatus.noRecords || eowp.kakin.hasRecord">
                                        <table class="table-custom table-custom-bordered">
                                            <thead>
                                                <tr>
                                                    <th class="th-header"><span class="row-text detail-title">サービス情報詳細</span></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr class="content-row">
                                                    <td><span class="row-text">ご注文番号：{{eowp.subscription.csOrderNo}}&#12288;ご注文日：{{eowp.subscription.oldSubscription ? eowp.subscription.oldSubscription.orderDate : eowp.subscription.orderDate}}</span></td>
                                                </tr>
                                                <tr class="content-row" v-if="eowp.subscription.oldSubscription">
                                                    <td><span class="row-text">※ ご注文番号の変更のお知らせ：{{eowp.subscription.oldSubscription.csOrderNo}} から変更されております。</span></td>
                                                </tr>
                                                <tr class="content-row" v-if="eowp.subscription.csOrderNo">
                                                    <td>
                                                        <span class="row-text">{{getItemName(eowp.subscription.csMatNo)}}</span>
                                                        <div 
                                                            @click="redirect('/products', 'switch_to_yearly_click')"
                                                            v-if="eowp.subscriptionType == 'MONTHLY' && notIn(eowp.subscription.useStatus, '0,2,3')" 
                                                            class="button buttons button-xs button-default-outline">
                                                            年額へ切り替え
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr class="content-row" v-if="eowp.kakin.hasRecord">
                                                    <td>
                                                        <span class="row-text">{{eowp.kakin.chargeTypes[eowp.kakin.record.chargeType]}}</span>
                                                    </td>
                                                </tr>
                                                <tr class="content-row" v-if="eowp.subscription.csOrderNo || eowp.kakin.hasRecord">
                                                    <td><span class="row-text">◆ご利用状況</span></td>
                                                </tr>
                                                <tr class="content-row" v-if="eowp.subscription.csOrderNo || eowp.kakin.hasRecord">
                                                    <td v-if="eowp.subscription.useStatus == '1'">
                                                        <span v-if="eowp.subscriptionType == 'MONTHLY'" class="row-text"><span class="font-bold" :class="this.eowp.subscriptionInfo.onTrialPeriod ? 'color-darkblue' : 'color-green'" v-html="eowp.subscriptionInfo.paymentReminder"></span>・当サービスは <strong>{{eowp.subscriptionInfo.nextBillingDate}}</strong> に自動継続され、¥<strong>{{formatPrice(eowp.subscriptionInfo.nextBillingAmount)}}</strong> をご請求いたします。</span>
                                                        <span v-if="eowp.subscriptionType == 'YEARLY'" class="row-text"><span class="font-bold" :class="this.eowp.subscriptionInfo.onTrialPeriod ? 'color-darkblue' : 'color-green'" v-html="eowp.subscriptionInfo.paymentReminder"></span>・当サービスは <strong>{{eowp.subscriptionInfo.nextBillingDate}}</strong> に自動継続され、¥<strong>{{formatPrice(eowp.subscriptionInfo.nextBillingAmount)}}</strong> をご請求いたします。</span>
                                                    </td>
                                                    <td v-if="eowp.subscription.useStatus == '0'">
                                                        <span class="row-text">{{ currentAccountStatusMessage }}</span>
                                                    </td>
                                                    <td v-if="eowp.subscription.useStatus == '2'">
                                                        <span v-show="!eowp.validToExpired || forcePayment()" class="row-text-contents text-justify"><span class="suspended-highlight color-red">サービス停止中</span>・利用を自動継続するには、<strong>{{eowp.subscriptionInfo.currentPeriodEnd}}</strong> までにカード情報の変更をお願いします。その際、未払いの料金 (<strong>¥{{formatPrice(eowp.subscriptionInfo.nextBillingAmount)}}</strong>) をご請求いたします。<strong>{{eowp.subscriptionInfo.currentPeriodEnd}}</strong> までにお手続きいただかないと、そのまま利用停止となります。</span>
                                                        <span v-show="eowp.validToExpired && !forcePayment() && eowp.subscriptionType == 'MONTHLY'" class="row-text">{{accountStatusMessages.stoppedBySystem}}</span>
                                                        <span v-show="eowp.validToExpired && !forcePayment() && eowp.subscriptionType == 'YEARLY'"  class="row-text">{{accountStatusMessages.stoppedBySystem}}</span>
                                                    </td>
                                                    <td v-if="eowp.subscription.useStatus == '3'">
                                                        <span class="row-text-contents text-justify"><span class="font-bold" :class="this.eowp.subscriptionInfo.onTrialPeriod ? 'color-darkblue' : 'color-green'" v-html="eowp.subscriptionInfo.paymentReminder"></span>・コース切り替え済み : <strong>{{eowp.subscriptionInfo.nextBillingDate}}</strong> より<strong>年額コース</strong>でのご利用となり、¥<strong>{{formatPrice(eowp.subscriptionInfo.nextBillingAmount)}}</strong> をご請求いたします。</span>
                                                    </td>
                                                    <td v-if="eowp.kakin.hasRecord">
                                                        <span class="row-text">ご利用中：サービスをご利用いただけます。</span>
                                                    </td>
                                                </tr>
                                                <tr class="content-row" v-if="eowp.kakin.hasRecord">
                                                    <td>
                                                        <span class="row-text text-left">有効期間の確認・カード情報の変更・利用停止のお手続きは、ご購入いただいたアプリストアまたは法人申し込み窓口にてお願いいたします。</span>
                                                    </td>
                                                </tr>
                                                <!-- Disable link to survey page, so we only currently offer survey to users during Cancellation Process-->
                                                <!-- <tr class="content-row" v-if="eowp.subscription.useStatus == '0'">
                                                    <td v-if="eowp.subscription.useStatus == '0'">
                                                        <span class="row-text">よろしければ、ご利用停止の
                                                            <a class="sub-link" href="#" @click.prevent="redirect('/survey')">アンケート</a>
                                                                にご協力ください。
                                                            </span>
                                                    </td>
                                                </tr> -->
                                                <tr class="content-row" v-if="eowp.subscription.csOrderNo">
                                                    <td>
                                                        <span class="row-text">利用開始日 : {{eowp.subscription.oldSubscription ? eowp.subscription.oldSubscription.validFrom : eowp.subscription.validFrom}}</span>
                                                        <div 
                                                            @click="changeCC(eowp.subscription.sendId, eowp.subscription.csOrderNo)"
                                                            v-if="(eowp.subscription.useStatus != '0' && !eowp.validToExpired) || forcePayment()" 
                                                            class="button buttons button-xs button-default-outline change-credit-card">
                                                            カード情報の変更・更新
                                                        </div>
                                                        <div @click="confirmSubscriptionInfoDialog()" v-if="showSubscriptionInfoLink() && ((eowp.subscription.useStatus != '0' && !eowp.validToExpired) || forcePayment())" class="subscription-info-link">{{eowp.subscriptionInfo.cardInfoLinkText}}</div> 
                                                    </td>
                                                </tr>
                                                <tr class="content-row" v-if="eowp.subscription.csOrderNo">
                                                    <td>
                                                        <span v-if="eowp.subscription.useStatus != '0'" class="row-text">利用停止日 : {{eowp.subscriptionCycle[eowp.subscription.useStatus]}}</span>
                                                        <span v-if="eowp.subscription.useStatus == '0'" class="row-text">利用停止日 : {{transformUseDescription(eowp.textReference[2], eowp.subscription.validTo)}} {{eowp.validToExpired ? '' : '（予定）'}}</span>
                                                        <div @click="updateService(eowp.requestType.RESUME, 'resume_subscription_click')"
                                                            v-if="!eowp.validToExpired && eowp.subscription.useStatus == '0'" class="button buttons button-xs button-default-outline"
                                                            v-bind:class="{'update-subscription-button disabled': isUpdateSubscriptionInProgress, 'disabled' : !isSubscriptionStatusButtonEnabled(eowp.requestType.RESUME) }">再開する</div>
                                                        <div @click="updateService(eowp.requestType.STOP, 'stop_subscription_click')"
                                                            v-if="!eowp.validToExpired && !notIn(eowp.subscription.useStatus, '1,3')" class="button buttons button-xs button-default-outline"
                                                            v-bind:class="{'update-subscription-button disabled': isUpdateSubscriptionInProgress, 'disabled' : !isSubscriptionStatusButtonEnabled(eowp.requestType.STOP) }">停止する</div>
                                                        <div v-if="eowp.controlSetting.paymentGateway.status == eowp.controlSetting.DISABLED" class="update-subscription-button-info">
                                                            <ul>
                                                            <li>{{eowp.updateSubscriptionMessage.MAINTENANCE_NOTE}}</li>
                                                            </ul>
                                                        </div>
                                                        <div v-else-if="showDisabledUpdateNote()" class="update-subscription-button-info">
                                                            <ul>
                                                            <li>{{eowp.updateSubscriptionMessage.DISABLED_UPDATE_NOTE}}</li>
                                                            </ul>
                                                        </div>
                                                        <div @click="redirect('/products', 'reorder_button_click')" v-if="(eowp.validToExpired && eowp.subscription.useStatus == '0') || eowp.validToExpired && (eowp.subscription.useStatus == '2' && eowp.validToExpired) && !forcePayment()" class="button buttons button-xs button-default-outline">再購入する</div>
                                                        <div @click="confirmSubscriptionInfoDialog()" v-if="showSubscriptionInfoLink() && !eowp.validToExpired && eowp.subscription.useStatus == '0'" class="subscription-info-link subscription-info-link-desktop2">{{eowp.subscriptionInfo.cardInfoLinkText}}</div> 
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <!-- END DESKTOP VERSION - PART1 -------------------->

                                    <!-- MOBILE VERSION - PART2 ------------------------->
                                    <div class="table-novi table-custom-responsive no-top-div mobile-component account-table" v-if="eowp.accountStatus.hasCurrentSubscription || eowp.accountStatus.hasPreviousShopSubscription || eowp.accountStatus.noRecords || eowp.kakin.hasRecord">
                                        <table class="table-custom table-custom-bordered">
                                            <thead>
                                                <tr>
                                                    <th class="th-header"><span class="row-text detail-title">お支払い履歴・明細</span></th>
                                                </tr>
                                            </thead>
                                            <tbody v-if="eowp.transactionHistory.length">
                                                <tr v-for="(obj, index) in eowp.transactionHistory" class="content-row" v-bind:key="'mobile-'+index" v-show="showTransaction(index)">
                                                    <td>
                                                        <div class="mobile-div-text">
                                                            <span class="row-text">{{obj.paymentDate}}&nbsp;&nbsp;</span>
                                                            <span class="row-text">{{eowp.paymentStatus[obj.paymentStatus]}}</span>
                                                            <span v-if="obj.firstMonthFree == '1'" class="row-text">{{purchasedTrialIndicator(obj)}}</span>
                                                        </div>
                                                        <br />
                                                        <div class="mobile-div-text">
                                                            <span class="row-text">{{eowp.paymentFrequencyDescription[eowp.subscriptionType]}}</span>
                                                            <span class="row-text">&nbsp;&nbsp;/&nbsp;&nbsp;</span>
                                                            <span class="row-text">{{formatPrice(obj.paymentPrice)}}円</span>
                                                        </div>
                                                        <br />
                                                        <div class="mobile-div-text-right" v-if="obj.receiptIssuedStatus == '1'">
                                                            <span v-if="obj.firstMonthFree != '1'" class="receipt-issued-mobile">領収書発行済み</span>
                                                        </div>
                                                        <div class="mobile-div-text" v-if="obj.receiptIssuedStatus == '0'">
                                                            <div 
                                                                @click="receipt(obj.csOrderNo, obj.paymentLogSeq, index)" 
                                                                v-if="obj.firstMonthFree != '1' && obj.paymentStatus != eowp.paymentStatusFlag.FAILED" 
                                                                class="button buttons button-xs button-default-outline mobile-button-transaction tooltip-grey-instant-title">
                                                                領収書を発行
                                                                <img class="loading-receipt-btn" v-if="nthReceiptButtonClicked == index" src="/images/eowp/animation/loading-spinner.jpg" />
                                                                <span class="tooltip-grey-instant-text" v-html="eowp.receiptPrintTooltip"></span>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>    
                                            </tbody>

                                            <tbody v-show="eowp.transactionHistory.length && eowp.transaction.currentItems == eowp.transaction.defaultItems && (eowp.transactionHistory.length > eowp.transaction.defaultItems)">
                                                <tr class="content-row">
                                                    <td>
                                                        <div class="mobile-div-text-center">
                                                            <span class="icon novi-icon icon-md icon-primary mdi mdi-menu-down"></span>
                                                            <a class="link" href="#!" @click="manageShowTransaction(eowp.transaction.maxItems, 'expand_transaction_list')">もっと見る</a>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                            <tbody v-show="eowp.transactionHistory.length && eowp.transaction.currentItems == eowp.transaction.maxItems && (eowp.transactionHistory.length > eowp.transaction.defaultItems)">
                                                <tr class="content-row">
                                                    <td>
                                                        <div class="mobile-div-text-center">
                                                            <span class="icon novi-icon icon-md icon-primary mdi mdi-menu-up"></span>
                                                            <a class="link" href="#!" @click="manageShowTransaction(eowp.transaction.defaultItems, 'collapse_transaction_list')">お支払い履歴を閉じる</a>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                            <tbody v-if="eowp.kakin.hasRecord">
                                                <tr class="content-row">
                                                    <td>
                                                        <div class="mobile-div-text">
                                                            <span class="row-text">当ショップでのお支払い履歴はありません。ご購入いただいたアプリストアまたは法人申し込み窓口にてご確認ください。</span>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                            <tbody v-if="!eowp.transactionHistory.length && !eowp.kakin.hasRecord">
                                                <tr>
                                                    <td class="content-row">
                                                        <div class="mobile-div-text">
                                                            <span class="row-text">お支払い履歴はありません。</span>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <!-- END MOBILE VERSION - PART2 --------------------->

                                    <!-- DESKTOP VERSION - PART2 ------------------------>
                                    <div class="table-novi table-custom-responsive no-top-div desktop-component account-table" v-if="eowp.accountStatus.hasCurrentSubscription || eowp.accountStatus.hasPreviousShopSubscription || eowp.accountStatus.noRecords || eowp.kakin.hasRecord">
                                        <table class="table-custom table-hover transaction-history-table">
                                            <thead>
                                                <tr>
                                                    <th class="th-header" colspan="5"><span class="row-text detail-title">お支払い履歴・明細</span></th>
                                                </tr>
                                            </thead>
                                            <tbody v-if="eowp.transactionHistory.length">
                                                <tr v-for="(obj, index) in eowp.transactionHistory" class="content-row" v-bind:key="index" v-show="showTransaction(index)">
                                                    <td><span class="row-text">{{obj.paymentDate}}</span></td>
                                                    <td>
                                                        <span class="row-text">{{eowp.paymentStatus[obj.paymentStatus]}}</span>
                                                        <span v-if="obj.firstMonthFree == '1'" class="row-text">{{purchasedTrialIndicator(obj)}}</span>
                                                    </td>
                                                    <td><span class="row-text">{{eowp.paymentFrequencyDescription[eowp.subscriptionType]}}</span></td>
                                                    <td><span class="row-text">{{formatPrice(obj.paymentPrice)}}円</span></td>
                                                    <td v-if="obj.receiptIssuedStatus == '1'">
                                                        <span v-if="obj.firstMonthFree != '1'" class="receipt-issued">領収書発行済み</span>
                                                    </td>
                                                    <td v-if="obj.receiptIssuedStatus == '0'">
                                                        <div 
                                                            @click="receipt(obj.csOrderNo, obj.paymentLogSeq, index)"
                                                            v-if="obj.firstMonthFree != '1' && obj.paymentStatus != eowp.paymentStatusFlag.FAILED" 
                                                            class="button buttons button-xs button-default-outline tooltip-grey-instant-title">
                                                            領収書を発行
                                                            <img class="loading-receipt-btn" v-if="nthReceiptButtonClicked == index" src="/images/eowp/animation/loading-spinner.jpg" />
                                                            <span class="tooltip-grey-instant-text" v-html="eowp.receiptPrintTooltip"></span>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                            <tbody v-show="eowp.transactionHistory.length && eowp.transaction.currentItems == eowp.transaction.defaultItems && (eowp.transactionHistory.length > eowp.transaction.defaultItems)">
                                                <tr class="content-row">
                                                    <td colspan="5">
                                                        <div class="click-to-load">
                                                            <span class="icon novi-icon icon-md icon-primary mdi mdi-menu-down"></span>
                                                            <a class="link" href="#!" @click="manageShowTransaction(eowp.transaction.maxItems, 'expand_transaction_list')">もっと見る</a>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                            <tbody v-show="eowp.transactionHistory.length && eowp.transaction.currentItems == eowp.transaction.maxItems && (eowp.transactionHistory.length > eowp.transaction.defaultItems)">
                                                <tr class="content-row">
                                                    <td colspan="5">
                                                        <div class="click-to-load">
                                                            <span class="icon novi-icon icon-md icon-primary mdi mdi-menu-up"></span>
                                                            <a class="link" href="#!" @click="manageShowTransaction(eowp.transaction.defaultItems, 'collapse_transaction_list')">お支払い履歴を閉じる</a>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                            <tbody v-if="eowp.kakin.hasRecord">
                                                <tr class="content-row">
                                                    <td colspan="5"><span class="row-text text-left">当ショップでのお支払い履歴はありません。ご購入いただいたアプリストアまたは法人申し込み窓口にてご確認ください。</span></td>
                                                </tr>
                                            </tbody>
                                            <tbody v-if="!eowp.transactionHistory.length && !eowp.kakin.hasRecord">
                                                <tr>
                                                    <td class="content-row" colspan="5"><span class="row-text">お支払い履歴はありません。</span></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <!-- END DESKTOP VERSION - PART2 -------------------->

                                    <form id="payment-portal" method="POST" :action="backendDomainUrl + '/payment-portal'" ref="paymentPortalForm">
                                        <input type="hidden" v-model="paymentParams.clientIp" name="clientip" />
                                        <input type="hidden" v-model="paymentParams.money" name="money" />
                                        <input type="hidden" v-model="paymentParams.telno" name="telno" />
                                        <input type="hidden" v-model="paymentParams.email" name="email" />
                                        <input type="hidden" v-model="paymentParams.sendId" name="sendid" />
                                        <input type="hidden" v-model="paymentParams.sendPoint" name="sendpoint" />
                                        <input type="hidden" v-model="paymentParams.sessionId" name="sessionid" />
                                        <input type="hidden" v-model="paymentParams.userId" name="userid" />
                                    </form>

                                    <div v-for="(obj, index) in eowp.previousSubscriptions" :key="index">
                                        <previous-subscription 
                                            :monthlyItem="eowp.products.monthly.item" 
                                            :yearlyItem="eowp.products.yearly.item" 
                                            :yearlySItem="eowp.products.yearlyS.item"
                                            :subscription="obj"
                                            :hasCurrentSubscription="eowp.accountStatus.hasCurrentSubscription"
                                            :hasPreviousShopSubscription="eowp.accountStatus.hasPreviousShopSubscription"
                                            v-if="eowp.loadPreviousSubscription"
                                        />
                                    </div>
                                    <div class="text-center button-product" v-if="!eowp.subscription.csMatNo && !eowp.kakin.hasRecord">
                                        <div class="button button-xl button-default-outline" @click="redirect('/products', 'buy_button_click')">「英辞郎 on the WEB Pro」を購入する</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <SubscriptionInfoDialog v-if="eowp.subscriptionInfo.dialog.enabled" :csOrderNo="eowp.subscription.csOrderNo" v-on:close="closeSubscriptionInfoDialog" />
        </div>
    </section>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media screen and (max-width: 360px){
    table td .mobile-button3{
        margin-left: 50%!important;
        left: -55px!important;
        float: left!important;
        margin-top: 10px!important;
    }
    table tr td .subscription-info-link-mobile2{
        position: relative;
        display: block !important;
        margin-left: 50%!important;
        left: -47px!important;
        float: left!important;
        margin-top: 10px!important;
    }
}
@media screen and (max-width: 475px){
    table td .mobile-button2{
        margin-left: 50%!important;
        left: -105px!important;
        float: left!important;
        margin-top: 10px!important;
    }
    table tr td .subscription-info-link-mobile{
        position: relative;
        margin-left: 50%!important;
        left: -50px!important;
        float: left!important;
        margin-top: 10px!important;
    }
}
@media screen and (max-width: 490px){
    table td .mobile-button1{
        margin-left: 50%!important;
        left: -78px!important;
        float: left!important;
        margin-top: 10px!important;
    }
}
@media screen and (max-width: 793px){
    .mobile-component{
        display: block!important;
    }
    .desktop-component{
        display: none!important;
    }
}
@media screen and (min-width: 793px){
    .desktop-component{
        display: block!important;
    }
    .mobile-component{
        display: none!important;
    }
}
.loading-receipt-btn{
    position: relative;
    display: inline;
    width: 15px;
    height: 15px;
    top: -3px;
}
td .mobile-button-transaction{
    margin-right: 0px!important;
    left: 8px!important;
}
.desktop-component{
    display: none;
}
.mobile-component{
    display: none;
}
.mobile-div-text{
    position: relative;
    display: block;
    white-space: normal;
    text-align: left;
}
.mobile-div-text-center{
    position: relative;
    display: block;
    white-space: normal;
    text-align: center;
}
.mobile-div-text-right{
    position: relative;
    display: block;
    white-space: normal;
    text-align: right;
}
.change-credit-card{
    background-color: #aaaaaa!important;
}
.text-justify{
    text-align: justify;
}
.sub-link{
    color: blue!important;
    cursor: pointer;
}
.sub-link-content{
    color: blue!important;
    position: relative;
    display: contents;
}
.row-with-sub-link {
    display: inline !important;
}
.receipt-issued{
    font-size: 14px;
    margin-right: 29px;
}
.button-product{
    padding-top: 25px!important;
}
.button-product .button {
    text-transform: none!important;
}
.header-instruction{
    font-size: 15px!important;
    color: #000000;
}
section div.table-containers{
    max-width: 83.33333%!important;
    flex: 0 0 83.33333%!important;
}
@media screen and (max-width: 991px){
    section div.table-containers{
        max-width: 100%!important;
        flex: 0 0 auto!important;
        padding-right: 14px!important;
    }
}
tr th.th-header{
    background-color: #eeeeee;
    border-bottom: 0px!important;
}
.no-top-div{
    position: relative;
    padding-top: 0px!important;
    margin-top: 0px!important;
    top: 0px!important;
}
a.link{
    color: blue;
}
.click-to-load{
    text-align: center;
}
.click-to-load span{
    position: relative;
    top: 3px;
}
.tab-content{
    padding-top: 0px!important;
}
.nav-tabs-checkout{
    border: 0px!important;
}
@media screen and (max-width: 767px){
    .nav-tabs-checkout{
        padding-bottom: 25px;
    }
    .header-instruction{
        font-size: 13px !important;
    }
}
table th{
    border-bottom-color: #bbbbbb;
}
.table-hover{
    border: 1px solid #eeeeee;
}
.text-left{
    text-align: left!important;
}
.row-text-align-right{
    float: right!important;
    padding-right: 10px!important;
}
.detail-title{
    font-weight: 1000;
    font-size: 16px;
}
.row-text{
    display: inline-flex;
    position: relative;
    float: left;
    min-width: 5px!important;
    white-space: pre-wrap;
}
.row-text-contents{
    display: inline;
    position: relative;
    float: left;
    min-width: 5px!important;
    white-space: pre-wrap;
}
.mobile-div-text .row-text {
    display: inline;
}
.mobile-div-text .row-text-contents {
    display: inline;
}
.section{
    padding-top: 60px!important;
    padding-bottom: 80px!important;
}
.buttons{
    position: relative!important;
    display: flex!important;
    float: right!important;
    margin-top: 0px!important;
    margin-right: 10px!important;
    font-size: 12px!important;
    height: 30px!important;
    line-height: 10px!important;
    min-width: 20px!important;
}
.subscription-info-link {
    font-size: 12px;
    text-decoration: underline;
    color: #0000FF;
    clear: both;
    float: right;
    padding-right: 11px;
    margin-top: 10px!important;
    cursor: pointer;
}
.subscription-info-link-desktop2{
    padding-right: 17px !important;
}
.subscription-info-link-mobile2{
    padding-right: 17px !important;
}
.form-buttons{
    padding-top: 30px;
}
.table-checkout{
    max-width: 1800px!important;
    width: auto!important;
}
.agreed-checkbox{
    padding-left: 0px!important;
}
.disabled{
    opacity: 0.5;
    pointer-events: none!important;
}
.page-loading-indicator > img {
    margin-top: 30px;
    width: 50px;
}

.table-custom th,
.table-custom td {
    padding: 15px 13px 15px 16px !important;
}
@media (max-width: 809px) and (min-width: 760px) {
    .table-custom th:first-child,
    .table-custom td:first-child {
        padding: 15px 14px 15px 20px !important;
    }
}
@media screen and (max-width: 990px) {
.tooltip-grey-instant-title .tooltip-grey-instant-text {
    top: -70px;
    right: 0% !important;
    height: 65px !important;
}
}

.tooltip-grey-instant-title .tooltip-grey-instant-text {
    top: -70px;
    height: 65px !important;
}

.update-subscription-button {
    cursor: progress;
}
.update-subscription-button-info{
    position: relative;
    display: block;
    float: right;
    width: 100%!important;
    text-align: right!important;
    padding-top: 8px!important;
}
.update-subscription-button-info ul{
    color: #838386!important;
    width: 300px!important;
    display: inline;
    right: 5px!important;
    position: relative;
    font-size: 9px;
}
@media screen and (max-width: 360px){
    div.update-subscription-button-info{
        float: left!important;
        text-align: center!important;
    }
    div.update-subscription-button-info ul{
        width: 100%!important;
        display: block!important;
        right: 0px!important;
        left: 3px!important;
    }
}
.suspended-highlight{
    position: relative;
    display: contents;
    font-weight: bold;
}
.color-red{
    color: red;
}
.color-green{
    color: #34ae5c;
}
.color-darkblue{
    color: #0080de;
}
.font-bold{
    font-weight: 600;
}

.alert {
    position: relative;
    padding-right: 50px !important;
}

.alert .close {
    position: absolute;
    right: 15px;
    top: 50%;
    transform: translateY(-50%);
}

.alert .alert-content {
    margin-right: 20px; 
}
</style>

<style>
.card-info-confirm-text{
    font-size: 11px;
}
@media screen and (max-width: 767px){
    .account-header-hidden-line{
        display: flex !important;
    }
}
</style>

<script>
import { BAlert } from "bootstrap-vue";
import { mapActions, mapGetters } from "vuex";
import Utils from '../../js/helpers/Utils';
import Constants from '../../js/helpers/Constants';
import PageControl from '../../js/helpers/PageControl';
import ReceiptPathFactory from '../../js/helpers/ReceiptPathFactory';
import PreviousSubscription from '../component/account/previous-subscription';
import BaseModel from '../../js/models/BaseModel';
import TransitionModel from '../../js/models/secure/TransitionModel';
import DialogMixin from '../../js/helpers/mixins/DialogMixin';
import SubscriptionInfoDialog from "../component/account/subscription-info-dialog";
import ShopConstants from '../../js/helpers/ShopConstants';
import CouponManager from '../../js/helpers/CouponManager';

export default {
    data(){
        return {
            pageLoadingIndicator: true,
            nthReceiptButtonClicked: -1,
            // Detailed information on subscriptions (web billing) ordered by entering credit card information at ALC's online store will be displayed.
            // Click "Issue Receipt" in the "Payment History and Details" section to output a receipt [one-time only / can be saved as a PDF file]. Receipts cannot be reissued.
            // For details and receipts for in-app purchases, etc., please check with the respective purchaser.
            headerInstructions: 'アルクのオンラインショップでクレジットカード情報を入力してご注文いただいたサブスクリプションの詳細情報が表示されます。<br /><div class="account-header-hidden-line" style="display:none">&nbsp;</div>' +
                '「お支払い履歴・明細」欄で「領収書を発行」を押すと、領収書が出力されます【<strong>１回限り</strong>／PDFファイルに保存可】。再発行はできませんのでご注意ください。<br />' +
                'アプリ内購入などの明細や領収書につきましては、それぞれの購入先でご確認をお願いいたします。',
            eowp: {
                products: {
                    monthly: {
                        item: [],
                        ref: 'EOWP_MONTHLY_ITEM'
                    },
                    yearly: {
                        item: [],
                        ref: 'EOWP_YEARLY_ITEM'
                    },
                    yearlyS: {
                        item: [],
                        ref: 'EOWP_YEARLY_S_ITEM'
                    },
                    subTypeRef: {
                        'EOWP_MONTHLY_ITEM': 'MONTHLY',
                        'EOWP_YEARLY_ITEM': 'YEARLY',
                        'EOWP_YEARLY_S_ITEM': 'YEARLY',
                    },
                    forcePayment: {
                        MONTHLY: true
                    },
                },
                subscription: [],
                subscriptionType: '',
                useStatuses: {
                    active: 1,
                    switched: 3
                },
                validToExpired: false,
                kakin: {
                    record: [],
                    hasRecord: false,
                    chargeTypes: {
                        0: 'None',
                        1: 'Shop',
                        2: '英辞郎 on the WEB Pro （アプリ内購入 [Apple]）',
                        3: '英辞郎 on the WEB Pro （アプリ内購入 [Google Play]）',
                        4: '英辞郎 on the WEB Pro （法人／団体購入）' //Bulk sale
                    },
                    chargeTypeShop: 1,
                },
                accountStatus: {
                    hasCurrentSubscription: false,
                    hasPreviousShopSubscription: false,
                    noRecords: true
                },
                transactionHistoryStatus: {
                    trials: {
                        TRIAL_OLD: '30',
                        TRIAL_NEW: '14',
                        indicators: {
                            '30': ' (初月無料適用) ',
                            '14': ' (初回購入のため2週間無料適用) ',
                        },
                    },
                },
                transactionHistory: [],
                transaction: {
                    defaultItems: 3,
                    maxItems: 99999999,
                    currentItems: 3
                },
                previousSubscriptions: [],
                previousSubscription: {
                    defaultItems: 1,
                    maxItems: 99999999,
                    currentItems: 1
                },
                subscriptionCycle: {
                    '1': '自動継続', //Automatic continuation
                    '3': '自動継続'  //Automatic continuation
                },
                paymentStatusFlag: {
                    FAILED: 2
                },
                paymentStatus: {
                    '1': 'ご請求済み', //Billed
                    '2': '未完了'     //Not finished (CC Card payment failure occurred)
                },
                paymentFrequencyDescription: {
                    'MONTHLY': '月額',
                    'YEARLY': '年額'
                },
                textReference: {
                    '1': '当サービスはYYYY年MM月に自動継続されます。',
                    '2': 'YYYY-MM-DD'
                },
                loadPreviousSubscription: false,
                requestType: {
                    STOP: 'stop',
                    RESUME: 'resume',
                    RECEIPT: 'receipt'
                },
                updateServiceDialog: {
                    'stop' : '停止',
                    'resume' : '再開',
                },
                receiptPrintTooltip: '&nbsp;発行は１回限りです。請求書も発行できます。あらかじめダウンロードの準備をお願いいたします。', //Issuance is limited to one time only. Invoices can also be issued. Please be prepared to download in advance.
                stripeSync: '',
                stripeSyncFlags: {
                    FAILED: 'FAILED',
                    SUCCESS: 'SUCCESS',
                },
                stripeSyncMessage: {
                    'FAILED': '更新が正常に完了しませんでした。再度ページを更新してください。この表示が続く場合、恐れ入りますが「英辞郎 on the WEB Pro」お問い合わせフォームからご連絡ください。', //The update did not complete successfully. Please refresh the page again. If this message persists, please contact us using the "Eijiro on the WEB Pro" Contact Form.
                    'SUCCESS': '更新が正常に完了しました。', //Update completed successfully.
                },
                stripeSyncPending: {
                    message: 'アカウント情報を更新中です。完了するまでしばらくお待ちください。', //Your account information is being updated. Please wait a moment until it is completed.
                },
                subscriberTypeMessage: {
                    ERR2: {
                        title: "エラーが発生しました", //An Error Occurred
                        body: "このアカウントで現在のサブスクリプションを見つけることができません。一度ログアウトして、再度サインインしてください。", // Unable to locate the current subscription under this account. Please logout and sign in again.
                        option: 'refreshPageNetworkErrorOptions'
                    },
                    DEFAULT_ERROR: {
                        title: '予期せぬエラーが発生しました', //Unexpected Error Occurred
                        body: '契約内容の更新に失敗しました。以下の情報を添えて管理者にお問い合わせください。', // Failed on updates on given subscription. Please contact the administrator with the following information.
                        option: 'refreshPageNetworkErrorOptions'
                    }
                },
                updateSubscriptionMessage: {
                    ERROR1: {
                        title: '予期せぬエラーが発生しました', //Unexpected Error Occurred
                        body: 'リクエストの転送中に予期せぬエラーが発生しました。ページを開き直して再度お試しください。', //An unexpected error has occurred while forwarding request. Please refresh the page and try again.
                        option: 'refreshPageOptions'
                    },
                    ERROR2: {
                        title: 'エラーが発生しました', //An Error Occurred
                        body: 'リクエストがシステムへ正常に到達しませんでした。再度お試しください。', //It failed to push the request to the system successfully. Please try again
                        option: 'refreshPageNetworkErrorOptions'
                    },
                    ERROR27: {
                        title: 'エラーが発生しました', //An Error Occurred
                        body: 'サブスクリプションの再開に失敗しました。 もう一度やり直してください。', //Failed to resume the subscription. Please try again
                        option: 'refreshPageNetworkErrorOptions'
                    },
                    ERROR28: {
                        title: 'エラーが発生しました', //An Error Occurred
                        body: 'サブスクリプションを停止できませんでした。 もう一度やり直してください。', //Failed to stop the subscription. Please try again
                        option: 'refreshPageNetworkErrorOptions'
                    },
                    DEFAULT_ERROR: {
                        title: '更新に失敗しました', //Update Failed
                        body: '契約内容の切り替えに失敗しました。再度試しても解決しない場合は、以下の情報を添えてお問い合わせください。', //Switching current subscription state failed, Please refresh the current page and try again. If this problem persist, please contact the admin with error reference',
                        option: 'refreshPageNetworkErrorOptions'
                    },
                    MAINTENANCE_NOTE: 'メンテナンス中のため変更を一次停止しております。',
                    DISABLED_UPDATE_NOTE: '変更を一次停止しております。'
                },
                subscriptionInfo: {
                    infoRequestType: {
                        SUBSCRIBER_TYPE: 2
                    },
                    dialog: {
                        enabled: false
                    },
                    isStripeSubscriber: false, // Primarily use to decide whether to show card info link or not. Only show the card info if the current subscription (top table) is Stripe
                    cardInfoLinkText: 'カード情報の照会',
                    nextBillingDate: '',
                    nextBillingAmount: '',
                    currentPeriodEnd: '',
                    onTrialPeriod: false,
                    paymentReminder: '',
                },
                controlSetting: {
                    paymentGateway: {
                        name: 'stripe_payment_gateway',
                        status: '',
                    },
                    stripeSubscriptionStop: {
                        name: 'stripe_subscription_stop',
                        status: '',
                    },
                    stripeSubscriptionResume: {
                        name: 'stripe_subscription_resume',
                        status: '',
                    },
                    ENABLED: '1',
                    DISABLED: '0',
                },
            },
            isUpdateSubscriptionInProgress: false,
            backendDomainUrl: '',
            paymentParams: {
                clientIp: '',
                money: '0',
                telno: '',
                email: '',
                sendId: '',
                sendPoint: 'CHANGE_CCINFO',
                sessionId: '',
                userId: ''
            },
            dialogParams: {
                defaultOptions: {
                    loader: false,
                    okText: 'OK',
                    cancelText: 'キャンセル', //Cancel
                    animation: 'zoom',
                    backdropClose: true
                },
                refreshPageOptions: {
                    loader: false,
                    okText: 'ページを更新する', //Refresh Page
                    cancelText: '閉じる', //Close
                    animation: 'zoom',
                    backdropClose: true
                },
                refreshPageNetworkErrorOptions: {
                    loader: false,
                    okText: '閉じる', //Close
                    cancelText: '閉じる', //Close
                    animation: 'zoom',
                    backdropClose: true
                },
                cardInfoOptions: {
                    loader: false,
                    okText: 'OK',
                    cancelText: 'キャンセル', //Cancel
                    animation: 'zoom',
                    backdropClose: true,
                    html: true,
                },
                receiptRedirectOptions: {
                    loader: false,
                    okText: '次へ', //Next
                    cancelText: 'キャンセル', //Cancel
                    animation: 'zoom',
                    backdropClose: true,
                    html: true,
                    title: '領収書と請求書ダウンロード画面を開く', //Open Receipt and Invoice Download Screen
                    prompt: '外部リンクにリダイレクトして表示されます。<br />ダウンロード画面が表示されない場合、ブラウザのポップアップ設定をご確認ください。', //You will be redirected to an external link. If the download screen does not appear, please check your browser's pop-up settings.
                },
                coupon: {
                    message: {
                        body: "今、サブスクリプションを続ければ、特典が適用されて、次回の決済価格が割り引かれます。その特典を利用しないで、このままサブスクリプションを停止してよいですか？" //Special dialogue message for cancelling users who have applied a coupon to their ongoing subscription
                    }
                },
                creditCard: {
                    message: {
                        title: 'Change Credit Card Information',
                        body: 'Are you sure you want to change '
                    },
                    options: {
                        loader: false,
                        okText: 'Change',
                        cancelText: 'Cancel',
                        animation: 'zoom',
                        backdropClose: true
                    }
                }
            },
            paramError: '',
            paramErrors: {
                '1': '送信パラメーターの不足が検出されました。お手数ですが一旦ログアウトし、再度ログインしてからお試しください。',
                '2': 'セッションのエラーまたは期限切れが検出されました。お手数ですが一旦ログアウトし、再度ログインしてからお試しください。',
                '3': 'セッション中のメールアドレスの不整合が検出されました。お手数ですが一旦ログアウトし、再度ログインしてからお試しください。',
                '4': '処理中にエラーが発生しました。お手数ですが再度お試しください。問題が解消しない場合は、お問い合わせください。',
                '500': 'このクーポンは現在ご利用いただけません。恐れ入りますが、再度お試しください。問題が解決しない場合は、<a target="_blank" href="' + ShopConstants.CONTACT_FORM_LINK + '">お問い合わせフォーム</a>よりご連絡をお願いいたします。 (error_code: 500)',
                '400': '処理中に予期せぬエラーが発生しました。時間をおいて再度お試しください。 解決しない場合は、<a target="_blank" href="' + ShopConstants.CONTACT_FORM_LINK + '">お問い合わせフォーム</a>よりご連絡をお願いいたします。 (error_code: 400)',
                '409': '「別タブからの操作で、サブスクリプションの停止手続きが行われています。いったん「再開する」を行った上で、あらためて「停止する」の操作をお願いします。(error_code: 409)',
                'default': '通信障害により処理の完了を確認できませんでした。恐れ入りますが、再度お試しください。解決しない場合はお手数ですが、<a target="_blank" href="' + ShopConstants.CONTACT_FORM_LINK + '">英辞郎 on the WEB お問い合わせフォーム</a>からお問い合わせください。',
            },
            ShopConstants,
            accountStatusMessages: {
                pending: 'ご利用停止予定：利用停止日までのご利用となります。',
                stoppedByUser: '停止：お客様の操作によりサービスを停止しました。またのご利用の際は「再購入する」よりお申し込みをお願いします。',
                stoppedBySystem: '終了：お支払い未完了で1カ月が経過したので、サービスは停止されました。再度ご利用になる場合は再購入してください。'
            },
        };
    },
    async created(){
        this.backendDomainUrl = BaseModel.getHost();
        let params = Utils.getParameters(window.location.href);
        if(params && params.error){
            this.paramError = params.error;
        } else if (params && params.sync) {
            this.eowp.stripeSync = params.sync;
        } else if (params && params.transition) {
            this.eowp.transition = params.transition;
        }

        // Clear those references if they reached on this page
        this.setPathIntention('');
        this.setChosenItem('');
        this.clearPaymentSuccessFlag();
        this.clearChangeCC();
        this.clearUpdateCCResult();
        this.clearPendingSubscriptionSync();
        this.clearTransitionStates();

        // Retrieve available products
        await this.retrieveProducts().then(res => {
            this.eowp.products.monthly.item = res.records.filter(obj => obj.itemType == this.eowp.products.monthly.ref)[0];
            this.eowp.products.yearly.item = res.records.filter(obj => obj.itemType == this.eowp.products.yearly.ref)[0];
            this.eowp.products.yearlyS.item = res.records.filter(obj => obj.itemType == this.eowp.products.yearlyS.ref)[0];
        });

        // Make sure session details are available
        if(this.userSessionId && !this.sessionDetails){
            await this.fetchSessionDetails(this.userSessionId);
            if(!this.sessionDetails){
                this.$router.push("/signin");
            }
        }

        // Retrieve user's current subscription
        await this.getCurrentSubscription(this.sessionDetails.userId).then(() => {
            this.eowp.subscription = !Utils.isEmpty(this.currentSubscription) ? this.currentSubscription : {};
            this.eowp.subscription.orderDate = Utils.formatDate(this.eowp.subscription.orderDate);
            this.eowp.subscription.orderDate = Utils.extractDateFromTimestamp(this.eowp.subscription.orderDate);
            this.eowp.subscription.validFrom = Utils.formatDate(this.eowp.subscription.validFrom);
            this.eowp.subscription.validFrom = Utils.extractDateFromTimestamp(this.eowp.subscription.validFrom);
            this.eowp.subscription.validTo = Utils.formatDate(this.eowp.subscription.validTo);
            this.eowp.subscription.validTo = Utils.extractDateFromTimestamp(this.eowp.subscription.validTo);
        });

        await this.dateExpired({custId: this.eowp.subscription.custId, csOrderNo: this.eowp.subscription.csOrderNo, compareTime: true}).then(res => {
            this.eowp.validToExpired = res.records;
        });

        //Pull kakinDB (ignore if expired)
        if((!this.eowp.subscription || !this.eowp.subscription.csMatNo) || this.eowp.validToExpired){
            await this.retrieveOtherSubscription({custId: this.sessionDetails.userId}).then(res => {
                if(res && res.records && res.records.result){
                    // Ignore kakindb for primary table if expired and there's expired/active shop subscription
                    let hasRecord = false;
                    if(res.records.result.inPeriod){
                        hasRecord = !hasRecord ? !Utils.isEmpty(res.records.result.chargeTypeDescription) : hasRecord;
                        hasRecord = hasRecord ? !Utils.isEmpty(res.records.result.expireDate) : hasRecord;
                        hasRecord = hasRecord ? (res.records.result.chargeType > this.eowp.kakin.chargeTypeShop) : hasRecord;
                    }
                    this.eowp.kakin.hasRecord = hasRecord;
                    this.eowp.kakin.record = (res.records.result.chargeType > this.eowp.kakin.chargeTypeShop) ? res.records.result : {};

                    console.log(this.countMonthsDifference(res.records.result.startDate, res.records.result.expireDate), "MONTHS DIFFERENCE");
                }
            });
        }

        // Remove expired/suspended current shop subscription if there's an active kakin, let active kakin prevail in main table
        if(this.eowp.subscription.useStatus != this.eowp.useStatuses.active && this.eowp.kakin.record.inPeriod){
            this.eowp.subscription = {};
        }

        // Determine the type of current subscription
        let node = null;
        node = Utils.isEmpty(node) ? (this.eowp.subscription.csMatNo == this.eowp.products.monthly.item.csMatNo ? this.eowp.products.monthly.item : node) : node;
        node = Utils.isEmpty(node) ? (this.eowp.subscription.csMatNo == this.eowp.products.yearly.item.csMatNo ? this.eowp.products.yearly.item : node) : node;
        node = Utils.isEmpty(node) ? (this.eowp.subscription.csMatNo == this.eowp.products.yearlyS.item.csMatNo ? this.eowp.products.yearlyS.item : node) : node;
        this.eowp.subscriptionType = !Utils.isEmpty(node) ? this.eowp.products.subTypeRef[node.itemType] : '';

        // Pull additional current subscription info
        if(this.currentSubscription){
            const currentCsMatNo = this.currentSubscription.useStatus == '3' ? this.eowp.products.yearly.item.csMatNo : this.currentSubscription.csMatNo;
            const currentCsOrderNo = this.currentSubscription.csOrderNo;
            const selectedProduct = this.products.filter(product => product.csMatNo == currentCsMatNo);
            this.eowp.subscriptionInfo.nextBillingAmount = selectedProduct.length > 0 ? selectedProduct[0].productPriceWithTax : '';
            await this.getInfo({requestId: 2, csOrderNo: currentCsOrderNo, format: 'yyyy/MM/dd (HH:mm)'}).then(res => {
                this.eowp.subscriptionInfo.nextBillingDate = res.records;
            });
            await this.getInfo({requestId: 3, csOrderNo: currentCsOrderNo, format: 'yyyy/MM/dd (HH:mm)'}).then(res => {
                this.eowp.subscriptionInfo.currentPeriodEnd = res.records;
            });

            // TODO: Remove this logic after February 2024
            if(this.eowp.subscription.useStatus == '2' && !this.eowp.validToExpired){
                let currentSubOrderDate = this.eowp.subscription.orderDate + " 00:00:00";
                
                let isOldUser = false;
                await this.getInfo({requestId: 369, format: currentSubOrderDate}).then(res => {
                    isOldUser = JSON.parse(res.records);
                });

                if(isOldUser){
                    const targetCsMatNo = this.eowp.subscription.csMatNo;
                    if(this.eowp.products.monthly.item.csMatNo == targetCsMatNo) this.eowp.subscriptionInfo.nextBillingAmount = '330';
                    if(this.eowp.products.yearly.item.csMatNo == targetCsMatNo) this.eowp.subscriptionInfo.nextBillingAmount = '3630';
                    if(this.eowp.products.yearlyS.item.csMatNo == targetCsMatNo) this.eowp.subscriptionInfo.nextBillingAmount = '3630';
                }
            } 

            try {

                switch (this.eowp.subscription.useStatus) {
                    case '2': {
                        // Fetch amount remaining for unpaid subscriptions
                        const getAmountRemainingResponse = await this.getInfo({ requestId: 5, csOrderNo: currentCsOrderNo });
                        this.eowp.subscriptionInfo.nextBillingAmount = getAmountRemainingResponse?.records ?? 0;
                        break;
                    }
                    case '3': {
                        // Fetch amount remaining for upgrading (monthly to yearly) subscriptions
                        const getUpcomingAmountResponseUpgrade = await this.getInfo({ requestId: 6, csOrderNo: currentCsOrderNo });
                        if (getUpcomingAmountResponseUpgrade?.records !== null)
                            this.eowp.subscriptionInfo.nextBillingAmount = getUpcomingAmountResponseUpgrade?.records;
                        break;
                    }
                    default: {
                        const getUpcomingAmountResponse = await this.getInfo({ requestId: 4, csOrderNo: currentCsOrderNo });
                        if (getUpcomingAmountResponse?.records !== null)
                            this.eowp.subscriptionInfo.nextBillingAmount = getUpcomingAmountResponse?.records;
                    }
                }
            } catch (error) {
                console.error("Error fetching next subscription amount info:", error);
            }
        }

        await this.retrievePreviousAnyItemSubscriptions({custId: this.sessionDetails.userId}).then(() => {
            if(this.previousAnyItemSubscriptions){
                this.eowp.previousSubscriptions = this.previousAnyItemSubscriptions.filter(obj => {
                    // Filter subs with use_status=1 when the current subscription is still monthly (use_status=3)
                    let allowed = obj.csOrderNo != this.eowp.subscription.csOrderNo;
                    if(allowed && parseInt(this.eowp.subscription.useStatus) == this.eowp.useStatuses.switched){
                        allowed = parseInt(obj.useStatus) != this.eowp.useStatuses.active;
                    }
                    return allowed;
                });
            }

            this.eowp.accountStatus.hasCurrentSubscription = !Utils.isEmpty(this.eowp.subscription) && !Utils.isEmpty(this.eowp.subscription.csMatNo);
            this.eowp.accountStatus.hasPreviousShopSubscription = !Utils.isEmpty(this.eowp.previousSubscriptions) && this.eowp.previousSubscriptions.length > 0;
            
            // Let's include previous Kakin subscriptions
            if(!this.eowp.kakin.record.inPeriod && !Utils.isEmpty(this.eowp.kakin.record.expireDate) && this.eowp.kakin.record.chargeType != this.eowp.kakin.chargeTypeShop){
                let kakinRecord = this.transformKakinRecord(this.eowp.kakin.record);
                this.eowp.previousSubscriptions.push(kakinRecord);
                this.eowp.accountStatus.noRecords = false;
            } else {
                // Detect no previous record(s)
                this.eowp.accountStatus.noRecords = !this.eowp.accountStatus.hasCurrentSubscription && !this.eowp.accountStatus.hasPreviousShopSubscription && !this.eowp.kakin.hasRecord;
            }
        });

        await this.refreshTransactionHistory(this.eowp.subscription.csOrderNo);
        this.eowp.subscriptionInfo.onTrialPeriod = this.eowp.transactionHistory.length == 1 && this.eowp.transactionHistory[0].firstMonthFree == '1';
        this.eowp.subscriptionInfo.paymentReminder = this.eowp.subscriptionInfo.onTrialPeriod ? '無料期間中' : 'ご利用中';

        await this.retrieveControls().then(res => {
            if(!res.records) return;
            this.eowp.controlSetting.paymentGateway = res.records.filter(obj => obj.name == this.eowp.controlSetting.paymentGateway.name)[0];
            this.eowp.controlSetting.stripeSubscriptionResume = res.records.filter(obj => obj.name == this.eowp.controlSetting.stripeSubscriptionResume.name)[0];
            this.eowp.controlSetting.stripeSubscriptionStop = res.records.filter(obj => obj.name == this.eowp.controlSetting.stripeSubscriptionStop.name)[0];
        })
        
        this.eowp.loadPreviousSubscription = true;
        this.pageLoadingIndicator = false;
        this.logActivity({type: "info", message: " Loaded Accounts Page with userId: " + this.sessionDetails.userId + " and sessionId: " + this.sessionDetails.sessionId});

        // Determine if this user has pending subscription for sync - asychronously
        await this.pendingSubscriptionSync({userId: this.sessionDetails.userId, sessionId: this.sessionDetails.sessionId});

        // Passively check backend for this user if it has stripe subscription record that was flagged as SYNC, execute the sync accordingly and refresh the page.
        this.autoSyncSubscription({userId: this.sessionDetails.userId, sessionId: this.sessionDetails.sessionId}).then(res => {
            if(!Utils.isEmpty(res.SYNC) && !isNaN(res.SYNC) && res.SYNC >= 0){ // We'll report whether the sync succeeded or failed
                let syncFlag = res.SYNC == 1 ? this.eowp.stripeSyncFlags.SUCCESS : this.eowp.stripeSyncFlags.FAILED;
                if(syncFlag == this.eowp.stripeSyncFlags.SUCCESS){
                    window.location.href = "/account?sync=" + syncFlag;
                } else {
                    this.clearPendingSubscriptionSync();
                    this.eowp.stripeSyncMessage[this.eowp.stripeSyncFlags.FAILED] = this.eowp.stripeSyncMessage[this.eowp.stripeSyncFlags.FAILED] + " [refId: " + res.SUBSCRIPTION_ID + "]";
                    this.eowp.stripeSync = syncFlag;
                }
            }
        });

        // Passively check backend if user is a Stripe Subscriber
        this.getSubscriptionInfo({
            userId: this.sessionDetails.userId, 
            sessionId: this.sessionDetails.sessionId,
            csOrderNo: this.eowp.subscription.csOrderNo, 
            infoRequestType: this.eowp.subscriptionInfo.infoRequestType.SUBSCRIBER_TYPE
        }).then(res => {
            if(res.records) {
                this.eowp.subscriptionInfo.isStripeSubscriber = res.records.isStripeSubscriber;
            }
        });
        const couponManager = new CouponManager(this);
        this.couponManager = couponManager;
    },
    watch: {
        sessionDetails: function(sessionValue) {
            new PageControl(this).validateSession(sessionValue);
        },
    },
    mounted() {
        if (this.$route.query.offerLoadFailed === 'true') {
            this.eowp.controlSetting.paymentGateway.status = this.eowp.controlSetting.ENABLED;
            this.eowp.controlSetting.stripeSubscriptionStop.status = this.eowp.controlSetting.ENABLED;
            this.updateService(this.eowp.requestType.STOP, 'stop_subscription_click');
            this.$router.replace({ query: null });
        }
        if (this.$route.query.error) {
            var errorCode = decodeURIComponent(this.$route.query.error);
            this.paramError = errorCode;
            this.$router.replace({ query: null });
        }
    },
    computed: {
        ...mapGetters({
            user: 'user/user',
            sessionDetails: 'user/session_details',
            pathIntention: 'user/path_intention',
            userSessionId: 'user/session',
            chosenItem: 'ncs/chosen_item',
            products: 'ncs/products',
            currentSubscription: 'ncs/current_subscription',
            previousAnyItemSubscriptions: 'ncs/previous_any_item_subscriptions',
            itemTransactionHistory: 'ncs/item_transaction_history',
            synced_subscription: 'pg/auto_sync_subscription',
            pending_auto_sync: 'pg/pending_auto_sync',
            subscriber: 'transition/subscriber_type',
        }),
        hasPendingSync: function(){
            return this.pending_auto_sync.SYNC > 0;
        },
        statusType() {
            if (!this.eowp.validToExpired) return 'pending';
            return this.isStoppedByUser() ? 'stoppedByUser' : 'stoppedBySystem';
        },
        currentAccountStatusMessage() {
            return this.accountStatusMessages[this.statusType];
        }
    },
    methods: {
        ...mapActions({
            setPathIntention: 'user/setPathIntention',
            fetchSessionDetails: 'user/fetchSessionDetails',
            setChosenItem: 'ncs/setChosenItem',
            retrieveProducts: 'ncs/retrieveProducts',
            retrieveSubscription: 'ncs/retrieveSubscription',
            retrieveOtherSubscription: 'ncs/retrieveOtherSubscription',
            retrieveControls: 'control/retrieveControls',
            getCurrentSubscription: 'ncs/getCurrentSubscription',
            retrievePreviousAnyItemSubscriptions: 'ncs/retrievePreviousAnyItemSubscriptions',
            getItemTransactionHistory: 'ncs/getItemTransactionHistory',
            dateExpired: 'ncs/dateExpired',
            updateReceiptStatus: 'ncs/updateReceiptStatus',
            updateService: 'cs/updateService',
            updateSubscriptionStatus: 'pg/updateSubscriptionStatus',
            logActivity: 'log/logActivity',
            trackClickEvent: 'ga/trackClickEvent',
            trackOutboundClickEvent: 'ga/trackOutboundClickEvent',
            clearPaymentSuccessFlag: 'pg/clearSuccessFlag',
            setChangeCC: 'pg/setUpdateCC',
            clearChangeCC: 'pg/setUpdateCC',
            clearUpdateCCResult: 'pg/clearUpdateCCResult',
            autoSyncSubscription: 'pg/autoSyncSubscription',
            pendingSubscriptionSync: 'pg/pendingSubscriptionSync',
            clearPendingSubscriptionSync: 'pg/clearPendingSubscriptionSync',
            getReceiptSource: 'pg/getReceiptSource',
            getSubscriptionInfo: 'ssr/getSubscriptionInfo',
            subscriberType: 'transition/subscriberType',
            setTransitionUserId: 'transition/setTransitionUserId',
            setTransitionCsMatNo: 'transition/setTransitionCsMatNo',
            setTransitionCsOrderNo: 'transition/setTransitionCsOrderNo',
            setTransitionType: 'transition/setTransitionType',
            clearTransitionStates: 'transition/clearStates',
            getInfo: 'info/getInfo',
            checkValidity: 'coupon/checkValidity',
            checkEligibility: 'coupon/checkEligibility',
            saveCouponId: 'coupon/saveCouponId',
            getCouponId: 'coupon/getCouponId',
        }),
        getItemName(itemNumber){
            let itemName = '';
            itemName = Utils.isEmpty(itemName) ? (itemNumber == this.eowp.products.monthly.item.csMatNo ? this.eowp.products.monthly.item.productName : itemName) : itemName;
            itemName = Utils.isEmpty(itemName) ? (itemNumber == this.eowp.products.yearly.item.csMatNo ? this.eowp.products.yearly.item.productName : itemName) : itemName;
            itemName = Utils.isEmpty(itemName) ? (itemNumber == this.eowp.products.yearlyS.item.csMatNo ? this.eowp.products.yearlyS.item.productName : itemName) : itemName;
            return itemName;
        },
        showTransaction(index){
            return index < this.eowp.transaction.currentItems;
        },
        manageShowTransaction(newValue, eventName){
            this.eowp.transaction.currentItems = newValue;
            this.trackClickEvent({event: eventName, path: this.$route.path, title: this.$route.meta.title});
        },
        showPreviousSubscription(index){
            return index < this.eowp.previousSubscription.currentItems;
        },
        manageShowPreviousSubscription(newValue){
            this.eowp.previousSubscription.currentItems = newValue;
        },
        transformUseDescription(text, givenDate, stepBack = false){
            let modifiedText = text;
            let extractedDate = givenDate.split('-');
            let targetYear = parseInt(extractedDate[0]);
            let targetMonth = parseInt(extractedDate[1]);
            let targetDate = parseInt(extractedDate[2]);

            if(stepBack){
                targetYear = (targetMonth > 1) ? targetYear : (targetYear - 1);
                targetMonth = (targetMonth > 1) ? (targetMonth - 1) : 12;
            }
            
            modifiedText = modifiedText.replace('YYYY', targetYear);
            modifiedText = modifiedText.replace('MM', targetMonth.toString().padStart(2, '0'));
            modifiedText = modifiedText.replace('DD', targetDate.toString().padStart(2, '0'));
            return modifiedText;
        },
        transformNextBillingDescription(text, givenDate){
            if(Utils.isEmpty(givenDate)) return text;
            let modifiedText = text;
            let extractedYear = givenDate.substring(0, 4);
            let extractedMonth = givenDate.substring(4, 6);

            let targetYear = parseInt(extractedYear);
            let targetMonth = parseInt(extractedMonth);
            
            modifiedText = modifiedText.replace('YYYY', targetYear);
            modifiedText = modifiedText.replace('MM', targetMonth);
            return modifiedText;
        },
        showDisabledUpdateNote(){
            // Also consider the subscription's useStatus
            return (this.eowp.controlSetting.stripeSubscriptionStop.status == this.eowp.controlSetting.DISABLED && !this.notIn(this.eowp.subscription.useStatus, '1,3')) ||
                    (this.eowp.controlSetting.stripeSubscriptionResume.status == this.eowp.controlSetting.DISABLED && this.eowp.subscription.useStatus == '0' );
        },
        isSubscriptionStatusButtonEnabled(requestFlag){
            return (requestFlag == this.eowp.requestType.RESUME) ?
                this.eowp.controlSetting.paymentGateway.status == this.eowp.controlSetting.ENABLED && this.eowp.controlSetting.stripeSubscriptionResume.status == this.eowp.controlSetting.ENABLED :
                this.eowp.controlSetting.paymentGateway.status == this.eowp.controlSetting.ENABLED && this.eowp.controlSetting.stripeSubscriptionStop.status == this.eowp.controlSetting.ENABLED;
        },
        getYearlyOfferProduct(){
            const yearlyProduct = this.products ? this.products.find(product => product.itemType == this.eowp.products.yearly.ref) : null;
            return yearlyProduct || (!Utils.isEmpty(this.eowp.products.yearly.item) ? this.eowp.products.yearly.item : null);
        },
        resolveStopIntentOfferCsMatNo(){
            if (Utils.isEmpty(this.currentSubscription)) return '';

            const yearlyProduct = this.getYearlyOfferProduct();
            if (this.currentSubscription.useStatus == '3' || this.eowp.subscriptionType == 'MONTHLY') {
                return yearlyProduct ? yearlyProduct.csMatNo : this.currentSubscription.csMatNo;
            }
            return this.currentSubscription.csMatNo;
        },
        isEmpty(object){
            return Utils.isEmpty(object);
        },
        notIn(needle, stack){
            return Utils.notIn(needle, stack);
        },
        async redirect(url, eventName){
            await this.trackClickEvent({event: eventName, path: this.$route.path, title: this.$route.meta.title});
            if(!Utils.isEmpty(url)){
                this.$router.push(url);
            }
        },
        async confirmSubscriptionInfoDialog(){
            if(!await this.checkActiveSession()) return;
                this.$dialog.confirm({
                    title: 'カード情報の照会', //Card Information Inquiry
                    body: 'カード情報を表示してよろしいですか？<br /><br /><span class="card-info-confirm-text">※表示される番号は下4桁のみです。</span>', //Are you sure you want to show your card information? *Only the last four digits of the number will be displayed.
                }, this.dialogParams.cardInfoOptions)
            .then(() => this.showSubscriptionInfoDialog())
        },
        showSubscriptionInfoDialog(){
            this.eowp.subscriptionInfo.dialog.enabled = true;
        },
        closeSubscriptionInfoDialog(){
            this.eowp.subscriptionInfo.dialog.enabled = false;
        },
        showSubscriptionInfoLink() {
            // Only show subscription info link/button for users with cancelled/active Stripe subscription
            return !this.eowp.validToExpired && !this.notIn(this.eowp.subscription.useStatus, '0,1,3') && this.eowp.subscriptionInfo.isStripeSubscriber;
        },
        async receipt(orderNo, paymentLogSeq, nthReceiptButton){
            // Skip request when there's already a request being processed
            if(this.nthReceiptButtonClicked >= 0) return;
            
            this.nthReceiptButtonClicked = nthReceiptButton;
            this.trackClickEvent({event: 'issue_ryoshusho_click', path: this.$route.path, title: this.$route.meta.title});
            if(!await this.checkActiveSession()) {
                this.nthReceiptButtonClicked = -1;
                return;
            }

            let externalReceiptSource = false;
            await this.getReceiptSource({sessionId: this.sessionDetails.sessionId, csOrderNo: orderNo, paymentLogSeq: paymentLogSeq}).then(async res => {
                if(res.records && res.records.receiptUrl){
                    externalReceiptSource = true;

                    this.$dialog.confirm({
                        title: this.dialogParams.receiptRedirectOptions.title,
                        body: this.dialogParams.receiptRedirectOptions.prompt,
                    }, this.dialogParams.receiptRedirectOptions)
                    .then(async () => {
                        Utils.forceOpenNewTab(res.records.receiptUrl);

                        //Execute receipt-view-only-once trigger, then refresh the transaction list
                        let vm = this;
                        setTimeout(()=>{ vm.nthReceiptButtonClicked = -1; }, 500);
                        await this.updateReceiptStatus({orderNo: orderNo, paymentLogSeq: paymentLogSeq});
                        this.refreshTransactionHistory(this.eowp.subscription.csOrderNo);
                        return;
                    }).catch(() => { this.nthReceiptButtonClicked = -1; });
                }
            });

            if(Utils.isEmpty(orderNo) || Utils.isEmpty(paymentLogSeq) || externalReceiptSource) return;
            let receiptPath = new ReceiptPathFactory("/receipt", this.sessionDetails.userId, this.sessionDetails.sessionId, this.eowp.subscriptionType, orderNo,paymentLogSeq);
            this.$router.push(receiptPath.finalPath);
            let vm = this;
            setTimeout(()=>{ vm.nthReceiptButtonClicked = -1; }, 500);
        },
        async refreshTransactionHistory(csOrderNo){
            await this.getItemTransactionHistory({orderId: csOrderNo}).then(() => {
                this.eowp.transactionHistory = this.itemTransactionHistory;
                this.eowp.transactionHistory = this.eowp.transactionHistory.map(obj => {
                    obj.paymentDate = Utils.formatDate(obj.paymentDate);
                    obj.paymentDate = Utils.extractDateFromTimestamp(obj.paymentDate);
                    return obj;
                });
                console.log(this.eowp.transactionHistory, "this.eowp.transactionHistory");
            });
        },
        async changeCC(sendId, csOrderNo){
            if(!await this.checkActiveSession()) return;
            if(Utils.isEmpty(sendId) || Utils.isEmpty(csOrderNo)) return;

            //Zeus to Stripe Transition Implementation
            let userId = this.sessionDetails.userId;
            let vm = this;
            await this.subscriberType({userId: userId, csOrderNo: csOrderNo}).then(res => {
                if(res.status_code != "ERR0"){
                    let errorRef = this.eowp.subscriberTypeMessage[res.status_code];
                    if (!errorRef) errorRef = this.eowp.subscriberTypeMessage['DEFAULT_ERROR'];

                    let errorParams = { error: { reference: errorRef, status_code: res.status_code } };
                    vm.errorMessage(errorParams);
                }
            });
            if(Utils.isEmpty(this.subscriber)) return;
            if(this.subscriber == TransitionModel.OLD_SUBSCRIBER){
                this.setTransitionUserId(this.eowp.subscription.custId);
                this.setTransitionCsMatNo(this.eowp.subscription.csMatNo);
                this.setTransitionCsOrderNo(this.eowp.subscription.csOrderNo);
                this.setTransitionType(TransitionModel.TRANSITION_TYPE_CCC);
                this.$router.push("/transition");
                return;
            } //End - Zeus to Stripe Transition Implementation

            //Stripe Implementation
            this.setChangeCC(csOrderNo);
            this.$router.push("/payment");

            this.trackAccountPageEvents('change_cc_click');
        },
        
        async updateService(requestFlag, eventName) {
            if(this.isUpdateSubscriptionInProgress || !await this.checkActiveSession()) return;

            // Popup for maintenance notification in case disabled stop/resume button failed
            if (!this.isSubscriptionStatusButtonEnabled(requestFlag)) {
                let vm = this;
                vm.$dialog.alert({
                    title: "ただいまメンテナンス中です", //Currently under maintenance.
                    body: "大変申し訳ございません。現在メンテナンス中のため操作を一次停止しております。メンテナンス終了後再度お試しください。" //The operation is temporarily stopped because it is currently under maintenance. Please try again after the maintenance is completed.
                }, vm.dialogParams.defaultOptions)
                return;
            }

            // Set flag to prevent multiple simultaneous requests
            this.isUpdateSubscriptionInProgress = true;

            // // Zeus to Stripe Transition Implementation
            // if(requestFlag == this.eowp.requestType.RESUME){
            //     let userId = this.sessionDetails.userId;
            //     let csOrderNo = this.eowp.subscription.csOrderNo;
            //     let vm = this;
            //     await this.subscriberType({userId: userId, csOrderNo: csOrderNo}).then(res => {
            //         if(res.status_code != "ERR0"){
            //             let errorRef = this.eowp.subscriberTypeMessage[res.status_code];
            //             if (!errorRef) errorRef = this.eowp.subscriberTypeMessage['DEFAULT_ERROR'];

            //             let errorParams = { error: { reference: errorRef, status_code: res.status_code } };
            //             vm.errorMessage(errorParams);
            //         }
            //     });
            //     if(Utils.isEmpty(this.subscriber)) return;
            //     if(this.subscriber == TransitionModel.OLD_SUBSCRIBER){
            //         this.setTransitionUserId(this.eowp.subscription.custId);
            //         this.setTransitionCsMatNo(this.eowp.subscription.csMatNo);
            //         this.setTransitionCsOrderNo(this.eowp.subscription.csOrderNo);
            //         this.setTransitionType(TransitionModel.TRANSITION_TYPE_RESUME);
            //         this.$router.push("/transition");
            //         return;
            //     }
            // } //End - Zeus to Stripe Transition Implementation

            var confirmationMessageBody = 'サブスクリプションを' + this.eowp.updateServiceDialog[requestFlag] + 'してよろしいですか？';
            if(requestFlag == this.eowp.requestType.STOP){
                const currentCsMatNo = this.currentSubscription.useStatus == '3' ? this.eowp.products.yearly.item.csMatNo : this.currentSubscription.csMatNo;
                const offerCsMatNo = this.resolveStopIntentOfferCsMatNo();
                const currentProduct = this.products.filter(product => product.csMatNo == currentCsMatNo);
                const offerProduct = this.products.filter(product => product.csMatNo == offerCsMatNo);
                const currentMerchantPrice = currentProduct.length > 0 ? currentProduct[0].merchantProductPrice : '';
                const offerMerchantPrice = offerProduct.length > 0 ? offerProduct[0].merchantProductPrice : '';
                if(this.eowp.subscriptionInfo.nextBillingAmount < currentMerchantPrice){
                    confirmationMessageBody = this.dialogParams.coupon.message.body; //nextBilling is less than merchantProductPrice, so there must be an ongoing coupon, and we dont need to check whether to show the offer page.
                }
                else{
                    try {
                        const promoCode = '';
                        var couponId;
                        const couponIdResponse = await this.couponManager.getCouponId(offerCsMatNo, 'stop_intent');
                        couponId = couponIdResponse.data.coupon_id;
                        const validityResponse = await this.couponManager.checkValidity(promoCode, couponId);
                        if (validityResponse.status_code == 200 && validityResponse.data.valid == true) { //Checks for a 200 response from the checkValidity call, and that the couponId was valid
                            const promoId = null;
                            const userId = this.sessionDetails.userId;
                            const freeMonth = false;
                            const eligibilityResponse = await this.couponManager.checkEligibility(userId, offerCsMatNo, promoId, couponId, freeMonth, offerMerchantPrice);
                            if (eligibilityResponse.status_code == 200) { //Checks for a 200 response from the checkEligibility call
                                if (eligibilityResponse.data.eligible == true) {
                                    // Mark the navigation intent so Offer page can verify user came from cancellation flow
                                    this.setPathIntention('/offer');
                                    this.$router.push("/offer");
                                    return
                                }
                                else{
                                    if(eligibilityResponse.data.reason_code == "INFO_116"){
                                        confirmationMessageBody = this.dialogParams.coupon.message.body
                                    }
                                    //else continue with default popup message
                                }
                            }
                        }
                        //so do nothing regarding the offer coupon and proceed to a normal cancel confirmation check, no offer page
                    } catch (error) {
                        console.warn(error)
                    }
                }
            }

            await this.$dialog.confirm({
                    title: '確認',
                    body: confirmationMessageBody,
                }, this.dialogParams.defaultOptions)
            .then(() => {
                let userId = this.sessionDetails.userId;
                let sessionId = this.sessionDetails.sessionId;
                let orderNo = this.eowp.subscription.csOrderNo;
                let request = requestFlag;

                this.updateSubscriptionStatus({
                    userId: userId,
                    sessionId: sessionId,
                    csOrderNo: orderNo,
                    request: request
                }).then(res => {
                    if (res.status_code == "ERROR2") {
                        this.$router.push("/signin");
                    } else if (res.status_code == "SUCCESS" || (res.responseCode == "200" && res.resultCode == "0")) {
                        // Let's reload the page once the update is successfully saved.
                        // Take stopping users to the survey page, instead of reloading the account page
                        if(requestFlag == this.eowp.requestType.STOP){
                            this.redirect('/survey');
                        }
                        else{
                            window.location.reload();
                        }
                    } else {
                        let errorRef = this.eowp.updateSubscriptionMessage[res.status_code];
                        if (!errorRef) errorRef = this.eowp.updateSubscriptionMessage['DEFAULT_ERROR'];

                        let errorParams = { error: { reference: errorRef, status_code: res.status_code } };
                        this.errorMessage(errorParams);
                    }
                    this.trackAccountPageEvents(eventName);
                }).catch(error => {
                    console.error('Update subscription status error:', error);
                }).finally(() => {
                    this.isUpdateSubscriptionInProgress = false;
                });
            }).catch(() => {
                // User cancelled the confirmation dialog
                this.isUpdateSubscriptionInProgress = false;
            });
        },
        errorMessage(res){
            if(res.error) {
                let statusCodes = new Array();
                if(res.error.status_code) statusCodes.push("StatusCode: " + res.error.status_code);
                if(res.error.responseCode) statusCodes.push("ResponseCode: " + res.error.responseCode);
                if(res.error.resultCode) statusCodes.push("ResultCode: " + res.error.resultCode);
                let finalStatusCodes = statusCodes.length > 0 ? statusCodes.join(",") : "";
                let errorRef = res.error.reference;

                this.$dialog.alert({
                    title: errorRef.title,
                    body: errorRef.body + " [" + finalStatusCodes + "]",
                }, this.dialogParams[errorRef.option])
                .then(() => window.location.reload())
                .catch(() => {});
            }
        },
        countMonthsDifference(fromDate, toDate){
            if(Utils.isEmpty(fromDate) || Utils.isEmpty(toDate)) return 0;
            try {
                let tempDateFrom = fromDate.split("T")[0];
                let tempDateTo = toDate.split("T")[0];
                let explodedDateFrom = tempDateFrom.split('-');
                let explodedDateTo = tempDateTo.split('-');
                let dateFrom = new Date(explodedDateFrom[0], explodedDateFrom[1]);
                let dateTo = new Date(explodedDateTo[0], explodedDateTo[1]);

                let monthsDiff = dateTo.getMonth() - dateFrom.getMonth();
                let yearsDiff = ((dateTo.getFullYear() - dateFrom.getFullYear()) * 12);
                return (monthsDiff + yearsDiff);
            } catch(err) {
                return 0;
            }
        },
        transformKakinRecord(kakinRecord){
            if(Utils.isEmpty(kakinRecord)) return null;

            //Determine csMatNo id equivalent of Kakin's subscription (yearly/monthly)
            let months = this.countMonthsDifference(kakinRecord.startDate, kakinRecord.expireDate);
            let objRef = (months >= 12) ? this.eowp.products.yearly : this.eowp.products.monthly;

            let record = {};
            record.csMatNo = objRef.item.csMatNo;
            record.csOrderNo = 'EXTERNAL-SUBSCRIPTION';
            record.custId = this.sessionDetails.userId;
            record.orderDate = kakinRecord.startDate;
            record.productName = this.eowp.kakin.chargeTypes[kakinRecord.chargeType];
            record.useStatus = '0';
            record.validFrom = kakinRecord.startDate;
            record.validTo = kakinRecord.expireDate + " 00:00:00";
            return record;
        },
        forcePayment(){
            return this.eowp.subscription.useStatus == this.eowp.paymentStatusFlag.FAILED.toString() && !this.eowp.validToExpired && this.eowp.products.forcePayment[this.eowp.subscriptionType];
        },
        isStoppedByUser() {
            // Check if this.eowp.transactionHistory is defined and not empty
            if (!Array.isArray(this.eowp.transactionHistory) || this.eowp.transactionHistory.length === 0) {
                return true; // Return true if transactionHistory is empty or undefined
            }

            // Find the most recent transaction based on billableYearMonth
            const mostRecentTransaction = this.eowp.transactionHistory.reduce((latest, current) => {
                return !latest || current.billableYearMonth > latest.billableYearMonth
                    ? current
                    : latest;
            }, null);

            // Check if the most recent transaction's paymentStatus is 2(payment failed)
            const paymentStatus = mostRecentTransaction?.paymentStatus;
            return paymentStatus !== "2";
        },
        trackAccountPageEvents(eventName){
            this.trackClickEvent({event: eventName, path: this.$route.path, title: this.$route.meta.title});
        },
        trackAccountPageHyperlinks(eventName, url){
            this.trackOutboundClickEvent({event: eventName, path: this.$route.path, title: this.$route.meta.title, url: url});
        },
        trackAccountPageRouterLink(eventName){
            this.trackClickEvent({event: eventName, path: this.$route.path, title: this.$route.meta.title});
        },
        purchasedTrialIndicator(orderDetail){
            let expired = Utils.dateExpired(Constants.EOWP_SHOP_SUBSCRIPTION_TRIAL_14_DAYS, orderDetail.paymentDate);
            let indicator = expired ?
                            this.eowp.transactionHistoryStatus.trials.TRIAL_NEW : 
                            this.eowp.transactionHistoryStatus.trials.TRIAL_OLD;
            return this.eowp.transactionHistoryStatus.trials.indicators[indicator];
        },
        formatPrice(price){
            return Utils.formatNumber(price);
        },
    },
    components: {
        PreviousSubscription,
        SubscriptionInfoDialog,
        BAlert
    },
    mixins: [
        DialogMixin
    ]
};
</script>
